import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AideQuotidienne from "../pages/aide-quotidienne/page";
import Conciergerie from "../pages/conciergerie/page";
import Contact from "../pages/contact/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-de-confidentialite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aide-quotidienne",
    element: <AideQuotidienne />,
  },
  {
    path: "/conciergerie",
    element: <Conciergerie />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-de-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;